
import { useI18n } from "vue-i18n";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Agreement Korean",
  setup() {
    const { t } = useI18n({ useScope: "global" });
    return { t };
  },
});
